import { render, staticRenderFns } from "./CheckoutDelivery.vue?vue&type=template&id=4f3bb660"
import script from "./CheckoutDelivery.vue?vue&type=script&lang=js"
export * from "./CheckoutDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports